import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { schoolSearchValidator } from '../ChildrenInfoWorkflowValidator';
import SchoolSearchInput from '../../../CommonComponents/SchoolSearchInput';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

const IsSpecificSchoolView = ({
  workflowId,
  branch,
  clientId,
  store,
  isEditingGoal,
  educationGoal,
  onPostProcess,
  nextIterators,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    id="SpecificCollegeName"
    canSkip={!educationGoal.IsSpecificCollege}
  >
    <Validation
      workflowId={workflowId}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.SpecificCollegeName`}
    />

    <h2 id="adv-search-college">Which college are you planning for?</h2>

    <SchoolSearchInput
      inputWrapperClassName="school-search-workflow-wrapper"
      className="school-search-workflow-input"
      clientId={clientId}
      value={educationGoal.SpecificCollegeName || ''}
      htmlPlaceholder="Search..."
      id="adv-search-college"
      onChange={selectedSchool => {
        store(workflowId)(
          {
            [BACKEND_EDUCATION_LIST_KEY]: {
              SpecificCollegeName: selectedSchool.Name,
              SpecificCollegeInformation:
                typeof selectedSchool === 'string' ? null : selectedSchool,
            },
          },
          clientId,
        );

        if (typeof selectedSchool !== 'string') {
          store(workflowId)(
            {
              [BACKEND_EDUCATION_LIST_KEY]: {
                SpecificCollegeIsPublic: !selectedSchool.IsPrivate,
                Amount: selectedSchool.InStateTotal,
                SpecificCollegeIsInState: true,
              },
            },
            clientId,
          );
        }
      }}
    />

    <Navigation
      nextIterators={nextIterators}
      dirtyGraphNodes={[]}
      validator={schoolSearchValidator(educationGoal.SpecificCollegeName)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.SpecificCollegeName`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      doNotSave={!isEditingGoal}
      onPostProcess={data => onPostProcess(data, educationGoal)}
      validatedOnClick={() =>
        workflowAnalyticsEvents(workflowId, 'education_specific_college_selected')
      }
    />
  </AdvWorkflowStep>
);

IsSpecificSchoolView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  isEditingGoal: PropTypes.bool.isRequired,
  educationGoal: PropTypes.shape({
    SpecificCollegeName: PropTypes.string,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

export default IsSpecificSchoolView;
